import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, Message, MessageService } from 'primeng/api';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { ResultData, UIService } from 'src/app/core/services/ui.service';
import { DataService } from 'src/app/services/data.service';
import { environment } from 'src/environments/environment';
import { FAZILService, UserService } from '../core/services';
import { UsuarioModel } from '../modelo/usuario.model';
import { validateDni, validateRUC } from '../shared/helpers';
import * as CryptoJS from 'crypto-js';
import { RegistroService } from '../registro/registro.service';

@Component({
    selector: 'app-app.resetpassword',
    templateUrl: './app.resetpassword.component.html'
})
export class AppResetpasswordComponent implements OnInit {

    //Variables de configuración/mensajes
    appConfig = environment.settings;

    errors: Object = {};
    msgs: Message[] = [];

    //Variables con objeto de edición
    user: UsuarioModel = new UsuarioModel();
    userDB: UsuarioModel = new UsuarioModel();

    //Variables auxiliares
    codigoVerificacion: string;
    mostrarFormRequest: boolean = true;
    mostrarFormCode: boolean = false;
    dataValid: boolean = true;
    intentos: number = 0;
    
    cargandoDataInit: boolean = false;
    procesando: boolean = false;
    processFilter = false;
    verificando: boolean = false;
    verificandoData: ResultData;
    resultData: ResultData;
    resultDataButtons: any[] = [];
    mostrarResultData: boolean = false;
    ui: UIService;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
        private fazilService: FAZILService,
        private uiService: UIService,
        private dataService: DataService,
        private confirmationService: ConfirmationService,
        private breadcrumbService: BreadcrumbService,
        private messageService: MessageService,
        private registroService: RegistroService,
    ) {
        this.ui = uiService;
    }

    ngOnInit(): void {
    }

    confirmarResetContrasenia(): void {
        this.ui.limpiarMessages();
        let msg = "Verificando credenciales " + (this.user.email ? ('para ' + this.user.email) : '');
        this.verificandoData = this.ui.buildResultFromVerify(msg, this.appConfig.ux.messagesType.success);
        this.verificando = true;
        if (!this.user.code || !this.user.email) {
                        this.verificando = false;
            this.ui.mostrarMensaje("error", `${this.appConfig.validationMsgs.formIvalid}`);
        } else if (!this.ui.isCIorRUC(this.user.code)) {
                        this.verificando = false;
            this.ui.mostrarMensaje("error", `${this.appConfig.validationMsgs.credentialsInvalid}`);
        } else {
                        this.verificando = false;
            this.confirmationService.confirm({
                message: `¿Está seguro de enviar la petición para <strong>actualizar su contraseña</strong>?.`,
                accept: () => {
                    this.enviarPeticionCambioContrasenia();
                },
            });
        }
    }

    enviarPeticionCambioContrasenia() {
        this.ui.limpiarMessages();
        this.verificandoData = this.ui.buildResultFromVerify(this.appConfig.ux.loadingMsg, this.appConfig.ux.messagesType.success);
        this.verificando = true;
        this.registroService.enviarPeticionResetContrasenia(this.user).subscribe(
            (data) => {
                if (data.userValid) {
                    this.mostrarFormRequest = false;
                    this.userDB = data;
                    this.verificando = false;
                    this.mostrarFormCode = true;
                } else {
                    this.resultData = this.ui.buildResultFromData(data.description, this.appConfig.ux.messagesType.error);
                    this.resultDataButtons = [];
                    this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonOk);
                    this.verificando = false;
                    this.mostrarResultData = true;
                }
            },
            (err) => {
                this.ui.mostrarError(err);
            }
        );
    }

    verificarCodigoVerificacion() {
        this.dataValid = false;
        let verifyCode: string = this.userDB.userCode;
        //TODO:: Agregar codigo desencriptado
        if (verifyCode == this.codigoVerificacion.trim()) {
            this.dataValid = true;
            //Redireccionar componente reset contrasenia
            this.registroService.setUserUUID(this.userDB.uuid);
            this.fazilService.irAResetContrasenia();
        } else {
            this.intentos = this.intentos + 1;
            if (this.intentos < 3) {
                this.ui.mostrarMensaje("error", `¡El código de verificación que ingresó es inválido.!`);
            } else {
                this.ui.mostrarMensaje("error", `¡Has excedido el número de intentos. Por favor vuelve a solicitar tu cambio de contraseña!`);
            }
        }
    }

    /**
    ** Métodos de formulario
    **/
    resetCodeVerificacion() {
        this.ui.limpiarMessages();
        this.codigoVerificacion = "";
        this.dataValid = true;
    }

    irALogin(event) {
        this.fazilService.irALogin();
    }

    ejecutarAccionResult(event, accion: string, item: any) {
        this.ui.limpiarMessages();
        if (accion == this.appConfig.ux.actionsExecute.close) {
            this.mostrarResultData = false;
        } else {
            this.ui.ejecutarAccionResultFromData(event, accion);//Acciones generales
        }
    }
}